import { useCallback, useEffect, useMemo, useState } from "react";
import { get_Users } from "services/users-roles";
import { change_lock_user, create_User, delete_User, edit_User, get_all_role } from 'services/auth/permission';
import Swal from 'sweetalert2';
import { t } from 'i18next';
import DataTable from 'react-data-table-component';
import LoadingOverlay from "general/components/LoadingOverlay";
import KTTooltip from "general/components/OtherKeenComponents/KTTooltip";
import BigInputField from "general/custom-fields/BigInputField";
import Modal_AddUser from "components/Modals/Modal_Adduser";
import Utils from "general/utils/Utils";
import Modal_EditUser from "components/Modals/Modal_EditUser";
import checkPermissionFunction from "Permission";
import { FUNCTION, PATH } from "pages/AuthorityRole/defineroles";
import Table from "components/Table";

const UserManagement = () => {
    const [Users, setUsers] = useState([]);
    const [UsersInSearch, setUsersInSearch] = useState([]);
    const [pending, setPending] = useState(true);

    const [roles, set_Roles] = useState([]);

    const [selectedRows, setSelectedRows] = useState([]);

    const [show, setShow] = useState({});

    // const contextActions = useMemo(() => {
    //     console.log(selectedRows)
    // }, [selectedRows]);

    const handleDeleteUser = async (selectedRows) => {

        let check = null;

        await Swal.fire({
            title: t('Notification'),
            text: "Bạn có chắc chắn muốn xóa người dùng này không?",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: t('Yes'),
            cancelButtonText: t('Cancel'),
            customClass: {
                confirmButton: 'btn btn-danger font-weight-bolder',
                cancelButton: 'btn btn-light font-weight-bolder',
            }
        }).then(async function (result) {
            if (result.value) {
                check = true;
            } else {
                check = false;
            }
        });

        await check != null;

        if (check == false) return;

        const res = await delete_User(selectedRows.map(item => item.username));
        Swal.fire({
            title: t('Notification'),
            text: res.data.message,
            icon: 'warning',
            // showCancelButton: true,
            confirmButtonText: t('Yes'),
            // cancelButtonText: t('Cancel'),
            customClass: {
                confirmButton: 'btn btn-danger font-weight-bolder',
                cancelButton: 'btn btn-light font-weight-bolder',
            }
        })

        if (res.data.status == 0) return

        refresh_User();
    }

    const confirmUpdate = async (values, actions) => {
        const res = await edit_User(values);

        Swal.fire({
            title: t('Notification'),
            text: res.data.message,
            icon: 'warning',
            // showCancelButton: true,
            confirmButtonText: t('Yes'),
            // cancelButtonText: t('Cancel'),
            customClass: {
                confirmButton: 'btn btn-danger font-weight-bolder',
                cancelButton: 'btn btn-light font-weight-bolder',
            }
        })

        if (res.data.status == 0) return

        actions.resetForm();

        refresh_User();
    }

    const handleEditUser = async (row) => {
        set_click_EDIT(true)

        set_SelectedRow(
            Object.entries(row).reduce((acc, [key, value]) => {
                acc[key] = value === null ? '' : value;
                return acc;
            }, {})
        );
    }

    const handleLockUser = async (row) => {

        let check = null;

        await Swal.fire({
            title: t('Notification'),
            text: `Bạn có chắc chắn muốn ${row.status == 'locked' ? "mở khóa" : "khóa"} người dùng này không?`,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: t('Yes'),
            cancelButtonText: t('Cancel'),
            customClass: {
                confirmButton: 'btn btn-danger font-weight-bolder',
                cancelButton: 'btn btn-light font-weight-bolder',
            }
        }).then(async function (result) {
            if (result.value) {
                check = true;
            } else {
                check = false;
            }
        });

        await check != null;

        if (check == false) return;

        const res = await change_lock_user(row.username, row.status == 'locked' ? 'isActive' : 'locked');
        Swal.fire({
            title: t('Notification'),
            text: res.data.message,
            icon: 'warning',
            // showCancelButton: true,
            confirmButtonText: t('Yes'),
            // cancelButtonText: t('Cancel'),
            customClass: {
                confirmButton: 'btn btn-danger font-weight-bolder',
                cancelButton: 'btn btn-light font-weight-bolder',
            }
        })

        if (res.data.status == 0) return

        refresh_User();
    }

    const columns = [
        {
            name: 'Tên đăng nhập',
            selector: (row) => row.username,
            hide: 'sm',

        },
        {
            name: 'Họ Tên',
            selector: (row) => row.fullname,

        },
        {
            name: 'Email',
            selector: (row) => row.email,
            hide: 'md',

        },
        {
            name: 'Số điện thoại',
            selector: (row) => row.phone,
            hide: 'md',

        },
        {
            name: 'Vai trò',
            select: "roleId",
            selector: (row) => roles.filter(item => item.roleId == row.roleId).map(item => item.name),
            hide: 'md',
        },
        {
            name: 'Trạng thái',
            selector: (row) => (
                <span className={row.status !== "locked" ? "text-primary" : "text-danger"}>
                    {row.status === "locked" ? "Đang khóa" : "Đang hoạt động"}
                </span>
            ),
            hide: 'md',
            button: false,
        },
        {
            name: "",
            cell: (row) => (
                <div className="d-flex align-content-center align-content-between w-full gap-2">
                    {
                        show?.[FUNCTION.edit] && <KTTooltip text={`${row.status == 'locked' ? 'Mở khóa' : 'Khóa'}`} >
                            <a className="btn btn-icon btn-sm btn-light-primary btn-hover-primary"
                                onClick={() => checkPermissionFunction(PATH.UserManagement, row.status == 'locked' ? FUNCTION.unlock : FUNCTION.lock, () => handleLockUser(row))}
                            >
                                <i className={`fa ${row.status == 'locked' ? 'fa-lock' : 'fa-unlock'} p-0 icon-1x`}></i>
                            </a>
                        </KTTooltip>
                    }
                    {
                        show?.[FUNCTION.edit] && <KTTooltip text="Chỉnh sửa">
                            <a className="btn btn-icon btn-sm btn-light-primary btn-hover-primary"
                                onClick={() => { checkPermissionFunction(PATH.UserManagement, FUNCTION.edit, () => handleEditUser(row)) }}
                            >
                                <i className="fa fa-pen p-0 icon-1x"></i>
                            </a>
                        </KTTooltip>
                    }
                    {/* {
                        show?.[FUNCTION.delete] && row.username != "admin" && <KTTooltip text="Xóa">
                            <a className="btn btn-icon btn-sm btn-light-danger btn-hover-danger"
                                onClick={() => checkPermissionFunction(PATH.UserManagement, FUNCTION.delete, () => handleDeleteUser([row]))}
                            >
                                <i className="fa fa-trash p-0 icon-1x"></i>
                            </a>
                        </KTTooltip>
                    } */}
                </div>
            ),
            button: true,
            center: true,
        }
    ]
    useEffect(() => {
        const fetchData = async () => {
            refresh_User();
            const roles = await get_all_role();
            set_Roles(roles.data.data);
        }
        fetchData();
    }, []);

    useEffect(() => {
        async function checkFunction() {
            let obj = {};
            obj[FUNCTION.edit] = await checkPermissionFunction(PATH.UserManagement, FUNCTION.edit);
            obj[FUNCTION.delete] = await checkPermissionFunction(PATH.UserManagement, FUNCTION.delete);
            obj[FUNCTION.unlock] = await checkPermissionFunction(PATH.UserManagement, FUNCTION.unlock);
            obj[FUNCTION.lock] = await checkPermissionFunction(PATH.UserManagement, FUNCTION.lock);
            obj[FUNCTION.add] = await checkPermissionFunction(PATH.UserManagement, FUNCTION.add);
            setShow(obj);
        }
        checkFunction();
    }, [])

    const handleSubmit = async (values, actions) => {

        // if (!validate(values)) return;

        const password = Utils.sha256(values.password);
        const res = await create_User({ ...values, password: password, status: "isActive" });

        Swal.fire({
            title: t('Notification'),
            text: res.data.message,
            icon: 'warning',
            // showCancelButton: true,
            confirmButtonText: t('Yes'),
            // cancelButtonText: t('Cancel'),
            customClass: {
                confirmButton: 'btn btn-danger font-weight-bolder',
                cancelButton: 'btn btn-light font-weight-bolder',
            }
        })

        if (res.data.status == 0) return

        actions.resetForm();

        refresh_User();
    }

    const refresh_User = async () => {
        setPending(true);
        const response = await get_Users();
        setUsers(response.data.filter(item => item.username != "admin"));
        setUsersInSearch(response.data.filter(item => item.username != "admin"));
        setPending(false);
    }

    const [initialValues, set_initialValues] = useState({
        username: '',
        email: '',
        fullname: '',
        phone: '',
        password: '',
    });

    const [selectedRow, set_SelectedRow] = useState({
        username: '',
        email: '',
        fullname: '',
        phone: '',
        password: '',
        roleId: ''
    })

    const reset_initialValues = () => {
        set_click_Add(true)
        set_initialValues({
            username: '',
            email: '',
            fullname: '',
            phone: '',
            password: '',
            roleId: ''
        })
    }

    const [click_Add, set_click_Add] = useState(false);
    const [click_Edit, set_click_EDIT] = useState(false);

    return (
        <div className="container-fluid min-h-100">
            <div className="h-100">
                <div className="card card-custom h-100">
                    <div className="card-header border-0 pt-6 pb-0">
                        <div className="w-100 d-flex justify-content-between">
                            <div className="card-title my-0">
                                <h3 className="card-label">Danh sách người dùng<span className="text-dark pt-2 font-size-sm d-block">Tổng: {Users.length} Người dùng</span></h3>
                            </div>
                            <div className="card-toolbar gap-2">
                                {
                                    show?.[FUNCTION.delete] &&
                                    <div
                                        className={`${selectedRows.length == 0 ? "d-none" : ""} btn btn-light-danger font-weight-bold align-items-center`}
                                        onClick={() => checkPermissionFunction(PATH.UserManagement, FUNCTION.delete, () => handleDeleteUser(selectedRows))}
                                    >
                                        <i className="fa fa-ban"></i>Xóa ({selectedRows.length})

                                    </div>
                                }
                                {
                                    show?.[FUNCTION.add] && <div className="btn btn-primary font-weight-bold d-flex align-items-center"
                                        onClick={() => checkPermissionFunction(PATH.UserManagement, FUNCTION.add, () => reset_initialValues())}
                                    >
                                        <i className="fa fa-plus"></i>
                                        Thêm người dùng
                                    </div>
                                }
                                {
                                    click_Add == true && <div className="modal fade show" data-bs-backdrop="static" data-bs-keyboard="false" tabIndex="-1" style={{ display: "block", paddingRight: "6px" }} role="dialog" aria-labelledby="staticBackdropLabel" aria-hidden="true">
                                        <div className="modal-dialog modal-lg">
                                            <Modal_AddUser
                                                initialValues={initialValues}
                                                onSubmit={handleSubmit}
                                                dismiss={() => set_click_Add(false)}
                                            />
                                        </div>
                                    </div>

                                }

                            </div>
                        </div>
                        <div className="d-flex flex-wrap">
                            <div className="input-icon mr-2 mt-4 mr-4">
                                <input type="text" className="form-control" placeholder="Tìm kiếm..."
                                    onChange={(e) => {
                                        const value = e.target.value;
                                        setUsersInSearch(Users.filter(item => item.username.toLowerCase().includes(value.toLowerCase())));
                                    }}
                                />
                                <span className="h-100">
                                    <i className="fal fa-search text-muted"></i>
                                </span>
                            </div>
                        </div>
                    </div>
                    <div className="card-body py-3 d-flex flex-column justify-content-between">
                        <Table
                            columns={columns}
                            data={UsersInSearch}
                            maxHeight={60}
                            values={(value) => setSelectedRows(value)}
                            progressPending={pending}
                        />
                    </div>
                </div>
            </div>
            {
                click_Edit && <div className="modal fade show" data-bs-backdrop="static" data-bs-keyboard="false" tabIndex="-1" style={{ display: "block", paddingRight: "6px" }} role="dialog" aria-labelledby="staticBackdropLabel" aria-hidden="true">
                    <div className="modal-dialog modal-lg">
                        <Modal_EditUser
                            initialValues={selectedRow}
                            onSubmit={confirmUpdate}
                            onrefresh={refresh_User}
                            dismiss={() => set_click_EDIT(false)}
                        />
                    </div>
                </div>
            }
        </div>
    )
}
export default UserManagement;